import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";
import { useResponsiveness } from "hooks/useResponsiveness";

const AmbassadorMobile = loadable(() => import("./Ambassador"), {
  fallback: <FullPageLoader />,
});

const AmbassadorDesktop = loadable(() => import("./Desktop"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const { windowWidth, isAbove } = useResponsiveness();
  const isDesktop = isAbove("sm");

  return (
    <ErrorBoundary>
      {windowWidth === null && <FullPageLoader />}
      {windowWidth !== null && isDesktop && <AmbassadorDesktop {...props} />}
      {windowWidth !== null && !isDesktop && <AmbassadorMobile {...props} />}
    </ErrorBoundary>
  );
};
